import { render } from "./Descisd.vue?vue&type=template&id=630f1c89"
import script from "./Descisd.vue?vue&type=script&lang=js"
export * from "./Descisd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__